// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tHrf","icon":"styles_icon__1JBwt"};